<template>
  <div class="container-fluid my-2 pt-3 pb-3 mb-4 bg-secondary-3">
    <div class="card-body bg-white">
      <div class="row mb-3">
        <div class="col-12">
          <div class="dot text-center">
            <i class="fas fa-edit title-icon" />
          </div>
          <span class="tag-badge-title-info pb-0">
            Listado de Evaluaciones Disponibles
          </span>
        </div>
      </div>
      <div class="panel-body">
        <MultiSelectionPicker
          :all-items="availables"
          :column-count="1"
          maxlength="1500"
          item-type-name=""
          :selected-items="selecteds"
        />
        <div class="row mt-3">
          <div class="col-12">
            <Error
              v-if="isSubmitted && selecteds.length <= 0"
              message="Favor seleccionar al menos una evaluación."
            />
          </div>
        </div>
        <CustomChipsGroup
          no-wrap
          object-text="name"
          :selected-items="selecteds"
          title="Evaluación(es) Seleccionada(s)"
          @itemMarkedForDeletion="removeSelection"
        />
      </div>
      <div class="actions">
        <ActionButton
          text="Cancelar"
          i="fas fa-times-circle"
          variant="custom-btn-return outline-danger"
          class="mr-2"
          @click="cancel"
        />
        <ActionButton
          text="Continuar"
          i="fas fa-arrow-alt-circle-right"
          variant="custom-btn-return success"
          @click="save"
        />
      </div>
    </div>
  </div>
</template>

<script>
import MultiSelectionPicker from '@/components/common/MultiSelectionPicker';
import CustomChipsGroup from '@/components/common/CustomChipsGroup';
import alertMixin from '@/mixin/alert.mixin';
import ActionButton from '@/components/common/ActionButton';
import Error from '@/components/common/Error';

const apiUrl = '/api/studentEvaluation';

export default {
  name: 'EvaluationSelection',
  components: {
    ActionButton,
    MultiSelectionPicker,
    CustomChipsGroup,
    Error,
  },
  mixins: [alertMixin],
  props: {
    evaluations: {
      type: Array,
      default: () => [],
    },
    selectedEvaluations: {
      type: Array,
      default: () => [],
    },
    serverSide: {
      type: Boolean,
      default: false,
    },
    readOnly: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      availableEvaluations: [],
      selectedItems: [],
      isSubmitted: false,
      endDate: '',
    };
  },
  async mounted() {
    if (this.serverSide) {
      await this.getEvaluations();
      return;
    }
    this.availableEvaluations = this.evaluations.map((s) => ({
      id: s.value,
      name: s.text,
    }));

    this.selectedItems = this.selectedEvaluations;
  },
  computed: {
    studentSie() {
      return this.$store.getters['$_student/StudentSie'];
    },
    evaluationsAddedList() {
      return (this.selectedEvaluations ?? []).map((x) => x.value).join(', ');
    },
    selecteds() {
      return (this.selectedItems ?? []).sort((a, b) =>
        a.name.localeCompare(b.name)
      );
    },
    availables() {
      return (this.availableEvaluations ?? []).sort((a, b) =>
        a.name.localeCompare(b.name)
      );
    },
  },
  methods: {
    async getEvaluations(selectedEvaluations) {
      const list = selectedEvaluations
        ? selectedEvaluations.map((x) => x.value).join(', ')
        : this.evaluationsAddedList;
      await Promise.all([
        this.getAvailablesEvaluations(list),
        this.getSelectedEvaluations(list),
      ]);
    },
    async getSelectedEvaluations(selectedEvaluations = '') {
      const url = `${apiUrl}/selectedevaluations?evaluationsIds=${selectedEvaluations}`;
      const { data } = await this.$ApiGet(url);
      this.selectedItems = (data ?? []).map((s) => ({
        ...s,
        id: s.id || s.value,
        name: s.name || s.text,
      }));
    },
    async getAvailablesEvaluations(selectedEvaluations) {
      const params = {
        studentSieId: this.studentSie,
        endDate: this.endDate,
        selectedEvaluations,
      };
      const url = `${apiUrl}/availablestudentsevaluations`;
      const { data } = await this.$ApiGet(url, params);
      this.availableEvaluations = (data ?? []).map((s) => ({
        ...s,
        id: s.id || s.value,
        name: s.name || s.text,
      }));
    },
    removeSelection(item) {
      const index = this.selectedItems.findIndex((e) => e.id === item.id);
      this.selectedItems.splice(index, 1);
      const exist = this.availableEvaluations.find((e) => e.id === item.id);
      if (!exist) this.availableEvaluations.push(item);
    },
    async save() {
      this.isSubmitted = true;
      if (this.selectedItems == null || this.selectedItems.length == 0) return;
      const selecteds = this.selectedItems.map((e) => ({
        ...e,
        value: e.value || e.id,
      }));
      const availables = this.availableEvaluations
        .map((e) => ({
          ...e,
          value: e.value || e.id,
        }))
        .filter((e) => !selecteds.some((sel) => sel.value === e.value));
      this.$emit('continue-select-many', selecteds, availables);
    },
    cancel() {
      this.$emit('cancel-select-many');
    },
  },
};
</script>
<style scoped>
.actions {
  display: flex;
  justify-content: flex-end;
}
.bg-gray {
  background-color: #f7f7f7;
}

.tag-badge-info {
  height: auto;
  padding: 0rem 1.2rem 0rem 0rem;
  display: inline-block;
  justify-content: space-between;
}
.tag-badge-success {
  background: #ffedbb no-repeat padding-box;
}
.tag-badge-main-info {
  background: #f5eee9 no-repeat padding-box;
  margin: 50px 0px 30px 0px;
}
.tag-badge-title-info {
  border-radius: 28px;
  font-family: 'Lato', sans-serif;
  font-weight: 700;
  letter-spacing: 0;
  color: #3f5b60;
  display: inline-block;
  padding-left: 1rem;
  margin-top: 5px;
}
.dot {
  background-color: white;
  box-shadow: 0px 3px 6px #00000029;
  margin: 2px;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  border-style: solid;
  border-width: 3px;
  border-color: #fff;
  display: inline-block;
}
.dot.green {
  background-color: #2db782;
}
.dot.gray {
  background-color: #3f5b60;
}

.title-icon {
  font-size: 1rem;
  color: #2db782;
  margin: 6px;
}
.line {
  position: relative;
  top: -24px;
}
.is-big-icon {
  margin-left: 3px;
}
/* style for reverse gradient. */
.tag-badge-reverse {
  display: inline-flex;
  padding-right: 1em;
  padding: 0rem 1.2rem 0rem 0rem;
  background: transparent linear-gradient(90deg, #fafbfa00 0%, #b5c3bc 100%) 0%
    0% no-repeat padding-box;
  border-radius: 26px;
  cursor: pointer;
}
.card-body {
  background-color: white;
}
@media screen and (max-width: 768px) {
  .tag-badge-title-info {
    font-size: unset !important;
  }
}
</style>
